var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemoryComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 348.0 348.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l348.0 0l0 348.0l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m-6.0 0l348.0 0l0 347.9685l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.07874 5.7758217l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.07874 5.7758217l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m29.351706 71.952896l225.32283 0l0 135.30708l-225.32283 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m151.08344 173.11288l-8.4375 0l0 -53.765617q-3.046875 2.90625 -8.0 5.8125q-4.9375 2.9062424 -8.875 4.3593674l0 -8.156242q7.078125 -3.328125 12.375 -8.0625q5.296875 -4.734375 7.5 -9.1875l5.4375 0l0 68.99999z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m29.351706 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.351706 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m57.005066 251.34212l-2.8125 0l0 -17.921875q-1.015625 0.96875 -2.671875 1.9375q-1.640625 0.96875 -2.953125 1.453125l0 -2.71875q2.359375 -1.109375 4.125 -2.6875q1.765625 -1.578125 2.5 -3.0625l1.8125 0l0 23.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m85.34121 211.62212l49.259834 0l0 70.29921l-49.259834 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m85.34121 211.62212l49.259834 0l0 70.29921l-49.259834 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m102.41644 245.29524l2.8125 -0.375q0.484375 2.390625 1.640625 3.453125q1.171875 1.046875 2.84375 1.046875q1.984375 0 3.34375 -1.375q1.375 -1.375 1.375 -3.40625q0 -1.9375 -1.265625 -3.1875q-1.265625 -1.265625 -3.21875 -1.265625q-0.796875 0 -1.984375 0.3125l0.3125 -2.46875q0.28125 0.03125 0.453125 0.03125q1.796875 0 3.234375 -0.9375q1.4375 -0.9375 1.4375 -2.890625q0 -1.546875 -1.046875 -2.5625q-1.046875 -1.015625 -2.703125 -1.015625q-1.640625 0 -2.734375 1.03125q-1.09375 1.03125 -1.40625 3.09375l-2.8125 -0.5q0.515625 -2.828125 2.34375 -4.375q1.828125 -1.5625 4.546875 -1.5625q1.875 0 3.453125 0.8125q1.578125 0.796875 2.40625 2.1875q0.84375 1.390625 0.84375 2.953125q0 1.484375 -0.796875 2.703125q-0.796875 1.21875 -2.359375 1.9375q2.03125 0.46875 3.15625 1.953125q1.125 1.46875 1.125 3.6875q0 3.0 -2.1875 5.09375q-2.1875 2.078125 -5.53125 2.078125q-3.015625 0 -5.015625 -1.796875q-1.984375 -1.796875 -2.265625 -4.65625z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m146.54593 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m146.54593 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m172.62117 251.34212l0 -5.484375l-9.9375 0l0 -2.578125l10.453125 -14.84375l2.296875 0l0 14.84375l3.09375 0l0 2.578125l-3.09375 0l0 5.484375l-2.8125 0zm0 -8.0625l0 -10.328125l-7.171875 10.328125l7.171875 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m205.43045 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m205.43045 211.62212l49.259842 0l0 70.29921l-49.259842 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m237.2713 248.63899l0 2.703125l-15.140625 0q-0.03125 -1.015625 0.328125 -1.953125q0.578125 -1.546875 1.84375 -3.046875q1.28125 -1.5 3.6875 -3.46875q3.734375 -3.0625 5.046875 -4.84375q1.3125 -1.796875 1.3125 -3.390625q0 -1.671875 -1.203125 -2.8125q-1.1875 -1.15625 -3.109375 -1.15625q-2.03125 0 -3.25 1.21875q-1.21875 1.21875 -1.234375 3.375l-2.890625 -0.296875q0.296875 -3.234375 2.234375 -4.921875q1.9375 -1.703125 5.203125 -1.703125q3.296875 0 5.21875 1.828125q1.921875 1.828125 1.921875 4.53125q0 1.375 -0.5625 2.703125q-0.5625 1.328125 -1.875 2.796875q-1.296875 1.46875 -4.328125 4.03125q-2.53125 2.125 -3.25 2.890625q-0.71875 0.75 -1.1875 1.515625l11.234375 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m276.51968 72.89239l52.661407 0l0 209.03937l-52.661407 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m276.51968 72.89239l52.661407 0l0 209.03937l-52.661407 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m289.1181 247.83202l27.46457 0l0 16.472458l-27.46457 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m289.1181 247.83202l27.46457 0l0 16.472458l-27.46457 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m289.1181 211.62204l27.46457 0l0 16.472443l-27.46457 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m289.1181 211.62204l27.46457 0l0 16.472443l-27.46457 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m289.1181 175.41208l27.46457 0l0 16.472443l-27.46457 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m289.1181 175.41208l27.46457 0l0 16.472443l-27.46457 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryComponent);
export default __webpack_public_path__ + "static/media/MemoryComponent.7acd34c4fa5bf782fc50e5e41520404f.svg";
export { ForwardRef as ReactComponent };